// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39bQ5","badges":"styles_badges__r1_4H"};